import LogicDistilleryAndFactory from "./dispatchTools/logicDistilleryAndFactory";
import TurnOffSuffixation from "./dispatchTools/turnOffSuffixation";
import ManageDispatch from './../../../../../../public/papconfig/MappingDispatch';

const DispatchControl = function(inputsToSend) {
    try {
        LogicDistilleryAndFactory.Apply(inputsToSend)
    } catch (e) {
        console.error(`DispatchControl: Falhar ao enviar os dados. ${e}`)
    }
    
    try {
        TurnOffSuffixation.CheckAndTurnOf(inputsToSend)
    } catch (e) {
        console.error(`DispatchControl: Falhar ao enviar os dados. ${e}`)
    }

    try {
        ManageDispatch(inputsToSend)
    } catch (e) {
        console.error(`ManageDispatch: Falhar ao enviar os dados. ${e}`)
    }
};

export default DispatchControl;